import { Source } from "pmt-types/src/models/Source.ts";
import { useMutation } from "react-query";
import { useAuthentication } from "../useAuthentication.ts";

export const useMutationUpsertSource = () => {
  const { accessToken } = useAuthentication();

  return useMutation(
    async (source: Source) => {
      const response = await fetch(`${import.meta.env.VITE_API_HOST}/sources`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: accessToken ?? "",
        },
        body: JSON.stringify(source),
      });

      if (!response.ok) {
        throw new Error(`Failed to upsert source`);
      }

      return (await response.json()) as Source;
    },
    {
      onError: (error, data) => {
        console.error("Failed to upsert source", error, data);
      },
    },
  );
};
